<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BkOtcz/tc-custom/9783968658506.jpg?1702957176515" alt="This image is the cover for the book Mrs Dalloway in Bond Street, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mrs Dalloway in Bond Street, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The story is an early experiment in stream of consciousness, a technique to convey the layers, textures, and loops of consciousness experienced by Clarissa. She leaves her house, meets an old friend, remembers the death of another, notices the other people in Bond Street and enters the glove shop. Virginia Woolf records the variety of thoughts in Clarissa’s head, memories, impressions, things she observes and muses upon, including the feeling of familiarity about the other customer in the glove shop.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Woolf
      </h2>
      
      <p class="authorDescription body article">Adeline Virginia Woolf, née Stephen; (25 January 1882 – 28 March 1941) was an English writer, considered one of the most important modernist 20th century authors and also a pioneer in the use of stream of consciousness as a narrative device. Woolf was born into an affluent household in South Kensington, London, the seventh child in a blended family of eight which included the modernist painter Vanessa Bell. Her mother was Julia Prinsep Jackson and her father Leslie Stephen. While the boys in the family received college educations, the girls were home-schooled in English classics and Victorian literature. An important influence in Virginia Woolf's early life was the summer home the family used in St Ives, Cornwall, where, in the late 1890s, she first saw the Godrevy Lighthouse, which was to become central to her novel To the Lighthouse (1927).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a20a280